import axiosPrivateMl from "./axiosPrivateMl"

const fetchFreshFacebookAdsets = async (payload) => {
	const response = await axiosPrivateMl.post("/fetch_fresh_facebook_adsets", payload)
	return response.data
}

export default fetchFreshFacebookAdsets
